/** Hostnames that serve the internal admin console (comma-separated in REACT_APP_ADMIN_HOSTNAME). */
function configuredAdminHostnames() {
  const raw = String(process.env.REACT_APP_ADMIN_HOSTNAME || "").trim();
  if (!raw) return [];
  return raw
    .split(",")
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean);
}

const LOCAL_ADMIN_HOSTS = new Set(["a6m1n708.localhost", "admin.localhost"]);

export function isAdminHost(hostname = window.location.hostname) {
  const host = String(hostname || "").trim().toLowerCase();
  if (!host) return false;
  if (LOCAL_ADMIN_HOSTS.has(host)) return true;
  return configuredAdminHostnames().includes(host);
}
